import {
  ApproverPolicy,
  IWorkflowPolicyFields,
  IWorkflowProcessor,
  IWorkflowProcessorExtension, IWorkflowValidateOptions, IWorkflowValidateTransitionOptions,
  setStateOptions
} from "../PA.Core.IF.Workflow";
import {
  WB_UserReviewerRow,
  WB_UserRow, WB_WorflowStatusHistoryLogRow,
  WB_WorflowStatusHistoryRow,
  WB_WorkflowRow,
  WB_WorkflowStatusRelationshipRow,
  WB_WorkflowStatusRow
} from "../PAdbSchemaRows";
import {BehaviorSubject} from "rxjs";
import {IPolicy} from "../PA.Core.IF.Policy";
import {IMessageProvider, IProgressProvider, MessageType} from "../PA.Core.IF.Basic";
import {MessageProvider} from "../Basic/Messages";
import {ProgressProvider} from "../Basic/Progress";
import {ESRecord} from "../lib/ESRecord";
import {PAdbContext} from "../PAdbContext";
import {
  esWB_Status_History,
  esWB_Status_History_Log,
  esWB_User,
  esWB_User_Reviewers,
  esWB_Workflow
} from "../PAdbSchema";
import {ESRecordResolver} from "../lib/ESRecordResolver";
import * as _ from 'lodash'
import {ASync} from "../Basic/ASync";
import {PAusrContext} from "../PAusrContext";
import {PAEnvironment} from "../PAEnvironment";
import {ESDataStore} from "../lib/ESDataStore";
import {TextUtils} from "../Basic/Text";
import {isFunction} from "rxjs/internal-compatibility";

let workflowProcessorNextId = 1

const bDebug = false

export interface IWorkflowProcessorOptions {
  dbContext?: PAdbContext
  object?: any
  WB_Cust_Id?: number

  bLoadWorkflowHistory?: boolean,
  bLoadUserReviewers?: boolean,
  WB_App_Id?: number,
  App_Id?: string,
  AppMgr_Id?: string

  Record?: ESRecord
  CurrentStateIdFieldName?: string
  NextStateIdFieldName?: string
  NextUserIdFieldName?: string
  OwnerUserIdFieldName?: string
}

const IWorkflowProcessorOptionsDefault: IWorkflowProcessorOptions = {
  dbContext: undefined,
  object: undefined,
  WB_Cust_Id: 0,

  bLoadWorkflowHistory: false,
  bLoadUserReviewers: false,
  WB_App_Id: 0,
  App_Id: "",
  AppMgr_Id: "",

  Record: undefined,
  CurrentStateIdFieldName: "",
  NextStateIdFieldName: "",
  NextUserIdFieldName: ""
}


export class WorkflowProcessor
  implements IWorkflowProcessor {

  private _bIsLoaded: boolean
  private _extensions: IWorkflowProcessorExtension[]

  private _options: IWorkflowProcessorOptions
  private _dbContext: PAdbContext
  private _usrContext: PAusrContext

  private _WorkflowProgressProvider: IProgressProvider
  private _WorkflowMessageProvider: IMessageProvider
  private _WorkflowId: number
  private _Workflow: WB_WorkflowRow
  private _WorkflowVisible: boolean
  private _dctByStatusType: { [id: string]: WB_WorkflowStatusRow[] }

  private _ValidateEnabled: boolean
  private _SaveEnabled: boolean
  private _OnSavedEnabled: boolean

  private _CurrentStateId: number
  private _CurrentState: WB_WorkflowStatusRow
  private _CurrentStateVisible: boolean

  private _NextStateEditable: boolean
  private _NextStateVisible: boolean
  private _NextStates: WB_WorkflowStatusRow[]
  private _NextStateId: number
  private _NextState: WB_WorkflowStatusRow
  private _NextUserId: number
  private _NextUser: WB_UserRow

  private _WorkflowStatusHistory: WB_WorflowStatusHistoryRow[]

  private _currentLogMessages: {code: string, message: string}[]


  private _bApproverRequired: boolean

  private _bUseApproverList: boolean
  private _ApproverList: WB_UserRow[]

  private _bUseReviewerList: boolean
  private _UserReviewerList: WB_UserReviewerRow[]


  private _PolicyChanged: BehaviorSubject<IPolicy>

  private _OnLoadComplete: Promise<void>

  private _workflowProcessorInstanceId: number

  constructor(pWB_Workflow_Id: number,
              pOptions: IWorkflowProcessorOptions) {
    workflowProcessorNextId += 1
    this._workflowProcessorInstanceId = workflowProcessorNextId
    this._bIsLoaded = false
    this._options = {}
    _.defaults(this._options, pOptions, IWorkflowProcessorOptionsDefault)

    switch (true) {
      case !_.isEmpty(this._options.dbContext):
        this._dbContext = this._options.dbContext
        break;
      default:
    }

    this._extensions = []
    this._usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
    this._currentLogMessages = []
    this._WorkflowProgressProvider = new ProgressProvider()
    this._WorkflowMessageProvider = new MessageProvider()
    this._WorkflowId = pWB_Workflow_Id
    this._Workflow = undefined
    this._WorkflowVisible = false
    this._dctByStatusType = {}

    this._ValidateEnabled = true
    this._SaveEnabled = true
    this._OnSavedEnabled = true


    this._CurrentStateId = 0
    this._CurrentState = undefined
    this._CurrentStateVisible = false
    this._NextStateEditable = false
    this._NextStateVisible = false
    this._NextStates = []
    this._NextStateId = 0
    this._NextState = undefined
    this._NextUserId = 0
    this._NextUser = undefined

    this._WorkflowStatusHistory = []
    this._bApproverRequired = false
    this._bUseApproverList = false
    this._ApproverList = []

    this._bUseReviewerList = false
    this._UserReviewerList = []

    this._PolicyChanged = new BehaviorSubject<IPolicy>(this)

    this._OnLoadComplete = undefined

  }

  setExtensions(arrExt: IWorkflowProcessorExtension[]): void {
    this._extensions = arrExt
  }

  get bIsLoaded(): boolean {
    return this._bIsLoaded
  }

  get OnLoadComplete(): Promise<void> {
    const self = this


    if (!_.isUndefined(self._OnLoadComplete)) {
      return self._OnLoadComplete
    }

    async function AsyncOnLoadComplete(): Promise<void> {

      let recordResolver = new ESRecordResolver(self.dbContext, {})
      await recordResolver.findAllWithRelationships(esWB_Workflow, [self.WorkflowId])

      self._Workflow = <WB_WorkflowRow>await recordResolver.get(esWB_Workflow, self.WorkflowId)

      // Load the Workflow History
      let AppMgrId = self._options.AppMgr_Id
      let WBAppId = self._options.WB_App_Id || 0
      let bValidIds = (!_.isEmpty(AppMgrId)) && (WBAppId > 0)
      if(bValidIds && self._options.bLoadWorkflowHistory) {
        self._WorkflowStatusHistory = <any[]> await recordResolver.queryAllWithRelationships(esWB_Status_History, {APPMGR_ID: AppMgrId, WB_APP_ID: WBAppId})
      }

      if(bValidIds && self._options.bLoadUserReviewers){
        self._UserReviewerList = <any[]> await recordResolver.queryAllWithRelationships(esWB_User_Reviewers, {APPMGR_ID: AppMgrId, WB_APP_ID: WBAppId})
      }

      // Use the record to setup the rest of the state.
      let rec:any = self._options.Record
      if(rec){
        let curId = undefined
        let nextId = undefined
        let nextUserId = undefined

        let sCurrentStateIdFieldName = self._options.CurrentStateIdFieldName
        if(!_.isEmpty(sCurrentStateIdFieldName)){
          curId = rec[sCurrentStateIdFieldName]
        }

        let sNextStateIdFieldName = self._options.NextStateIdFieldName
        if(!_.isEmpty(sNextStateIdFieldName)){
          nextId = rec[sNextStateIdFieldName]
        }

        let sNextUserIdFieldName = self._options.NextUserIdFieldName
        if(!_.isEmpty(sNextUserIdFieldName)){
          nextUserId = rec[sNextUserIdFieldName]
        }

        if(!_.isUndefined(nextUserId) && !_.isNaN(nextUserId)){
          self._NextUserId = nextUserId
          self._NextUser = await self.dbContext.find(esWB_User, nextUserId)
        }

        await self.setState(curId, nextId, {bStatusLogHistory: false})

      }

      self._bIsLoaded = true
      await self._handleExtensionExecution("OnLoad", [self])
    }

    let returnValue = AsyncOnLoadComplete()
    self._OnLoadComplete = returnValue
    return returnValue
  }

  get dbContext(): PAdbContext { return this._dbContext }

  get WorkflowProgressProvider(): IProgressProvider { return this._WorkflowProgressProvider }

  get WorkflowMessageProvider(): IMessageProvider { return this._WorkflowMessageProvider }

  get WorkflowId(): number { return this._WorkflowId }

  get Workflow(): WB_WorkflowRow { return this._Workflow }

  get WorkflowVisible(): boolean { return this._WorkflowVisible }

  get CurrentStateId(): number { return this._CurrentStateId }

  get CurrentState(): WB_WorkflowStatusRow { return this._CurrentState }

  get CurrentStateVisible(): boolean {
    return this._CurrentStateVisible
  }

  get NextStateEditable(): boolean { return this._NextStateEditable }

  get NextStateVisible(): boolean { return this._NextStateVisible }

  get NextStates(): WB_WorkflowStatusRow[] { return this._NextStates }
  get NextStateId(): number {  return this._NextStateId }

  set NextStateId(value: number) {
      this.setState(undefined, _.toNumber(value))
  }

  get NextState(): WB_WorkflowStatusRow { return this._NextState }

  get NextUserId(): number {
    return this._NextUserId
  }

  set NextUserId(value) {
    this._NextUserId = _.toNumber(value)
    let rec:any = this._options.Record
    let nextAppr = this._options.NextUserIdFieldName
    if(rec && !_.isEmpty(nextAppr)){
      rec[nextAppr] = this._NextUserId
    }
    this.updateNextUserRecord()

  }

  get NextUser(): WB_UserRow { return this._NextUser }

  get WorkflowStatusHistory(): WB_WorflowStatusHistoryRow[] { return this._WorkflowStatusHistory }

  get bApproverRequired(): boolean { return this._bApproverRequired }

  get bUseApproverList(): boolean { return this._bUseApproverList }

  get ApproverList(): WB_UserRow[] { return this._ApproverList }

  get bUseReviewerList(): boolean { return this._bUseReviewerList }

  get UserReviewerList(): WB_UserReviewerRow[] { return this._UserReviewerList }

  get PolicyChanged(): BehaviorSubject<IPolicy> { return this._PolicyChanged }

  clearStatusHistoryLog(): void {
    this._currentLogMessages = []
  }

  addStatusHistoryLogMessage(sCode: string, sMessage:string): void {
    this._currentLogMessages.push({code: sCode, message: sMessage})
  }

  removeStatusHistoryLogMessage(sCode: string): void {
    _.remove(this._currentLogMessages, (aMsg) => aMsg.code == sCode)
  }

  Validate(options?: IWorkflowValidateOptions): Promise<void> {
    return this.ValidateUsing(options || {}, true)
  }

  ValidateTransition(options?: IWorkflowValidateTransitionOptions): Promise<void> {
    return this.ValidateUsing(options || {}, false)
  }

  ValidateUsing(options: IWorkflowValidateOptions, bInclOnValidateSucces: boolean): Promise<void> {
    const self = this

    if(!self.ValidateEnabled){ return ASync.resolve() }  // should we ignore this if excluding bInc

    return new Promise<void>((resolve, error) => {

      self.WorkflowProgressProvider.start("Validate")
      self.WorkflowMessageProvider.clearMessages()

      let bExit =    !self.ValidateEnabled

      self._handleExtensionExecution("Validate", [self, options || {}])
        .then((ignore) => {
          if(self.WorkflowMessageProvider.countMessages(MessageType.Error) > 0){
            bExit = true
          }

          // Check if the Validate Function disabled itself.
          if(!self.ValidateEnabled){
            bExit = true
          }

          if(bExit){ return }

          if(bInclOnValidateSucces) {
            return self._handleExtensionExecution("OnValidatationSucess", [self, options || {}])
          }

        })
        .then((ignore) => {
          if(bExit){ return }

          if(bInclOnValidateSucces) {
            return self._OnValidateSuccess()
          }
        })
        .then((ignore) => {
          self.WorkflowProgressProvider.finish()
          resolve()
        })
        .catch((err) => {
          self.WorkflowProgressProvider.exception(err)
          error(err)
        })
    })
  }


  private _OnValidateSuccess(): Promise<void> {
    const self = this

    self.WorkflowMessageProvider.clearMessages()

    return new Promise<void>((resolve, error) => {

      let AppMgrId = self._options.AppMgr_Id
      let WBAppId = self._options.WB_App_Id || 0
      let AppId = self._options.App_Id

      let bValidIds = (!_.isEmpty(AppMgrId)) && (WBAppId > 0)

      // Generate Workflow Transitions as needed..
      ASync.resolve()
        .then((ignore) => {

          if (!_.isEmpty(self._WorkflowStatusHistory)) {
            return
          }

          if (!bValidIds) {
            return
          }

          // Create a Record for the Current State..

          return self.dbContext.createRecordWithKey(esWB_Status_History)
            .then((aNewRec: WB_WorflowStatusHistoryRow) => {
              aNewRec.setDefaults()
              aNewRec.cif.WB_APP_ID = WBAppId
              aNewRec.cif.APP_ID = AppId
              aNewRec.cif.APPMGR_ID = AppMgrId
              aNewRec.cif.WB_STATUS_ID = self._CurrentStateId
              self.dbContext.add(esWB_Status_History, aNewRec)
              self._WorkflowStatusHistory.push(aNewRec)
            })

        })
        .then((ignore) => {
          // Check if there is a state Transition

          if(_.isEmpty(self._currentLogMessages)) {
            if ((self.CurrentState.cif.WB_STATUS_ID == self.NextState.cif.WB_STATUS_ID)) {
              return
            }

            for(let ext of self._extensions) {
              if(isFunction(ext.LogTransitionCondition)) {
                if(!ext.LogTransitionCondition(self))
                  return
              }
            }
          }

          if (!bValidIds) {
            return
          }

          let LogParentRec: WB_WorflowStatusHistoryRow = undefined
          // Create Transition record and Create Log entries
          return self.dbContext.createRecordWithKey(esWB_Status_History)
            .then((aNewRec: WB_WorflowStatusHistoryRow) => {
              aNewRec.setDefaults()
              aNewRec.cif.WB_APP_ID = WBAppId
              aNewRec.cif.APP_ID = AppId
              aNewRec.cif.APPMGR_ID = AppMgrId
              aNewRec.cif.WB_STATUS_ID = self._NextStateId
              self.dbContext.add(esWB_Status_History, aNewRec)
              self._WorkflowStatusHistory.push(aNewRec)
              LogParentRec = aNewRec
            })
            .then((ignore) => {
              async function CreateLogRecordsAsync() {
                if (_.isEmpty(self._currentLogMessages)) {
                  return
                }

                let sort = 1
                for (let idx in self._currentLogMessages) {
                  let logMessage = self._currentLogMessages[idx]
                  let splitMessage = TextUtils.splitConservingWords(logMessage.message, 85)
                  for (let msgIdx in splitMessage) {
                       let rowMsg = splitMessage[msgIdx]
                    let newLogRec: WB_WorflowStatusHistoryLogRow = <any>await self.dbContext.createRecordWithKey(esWB_Status_History_Log)
                    newLogRec.cif.LOG_SORT = TextUtils.padStart(sort + '', 4, '0')
                    newLogRec.cif.LOG_MESSAGE = rowMsg
                    newLogRec.cif.LOG_MESSAGE_CD = logMessage.code
                    newLogRec.cif.WB_STATUSH_ID = LogParentRec.cif.WB_STATUSH_ID
                    sort += 1
                    self.dbContext.add(esWB_Status_History_Log, newLogRec)
                  }
                }
              }

              return CreateLogRecordsAsync()
            })
        })
        .then((ignore) => {
              // Transition Workflow State if there is a change
              if (self.CurrentState.cif.WB_STATUS_ID == self.NextState.cif.WB_STATUS_ID) {
                return
              }
              if(bDebug) {
                console.log(`_OnValidateSuccess_OnValidateSuccess (${self._workflowProcessorInstanceId}): Transitioning to ${self.NextState.cif.WB_STATUS_ID}`)
                console.log(JSON.stringify(self._options.Record))
              }
              return self.setState(self.NextState.cif.WB_STATUS_ID, undefined, {bStatusLogHistory: false})
            })
            .then((ignore) => {
              resolve()
            })
            .catch((err) => {
              error(err)
            })

        })

  }

  get ValidateEnabled(): boolean {
    return this._ValidateEnabled
  }

  Save(bUseBatch?: boolean, options?: any): Promise<void> {
    const self = this

    if(!self.SaveEnabled){ return ASync.resolve() }

    return new Promise<void>((resolve, error) => {
      var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
      if (bUseBatch) {
        saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
      } else {
        saveFunction = self.dbContext.Save.bind(self.dbContext)
      }

      // Can we save a subset of the record values..
      self.WorkflowProgressProvider.start("Saving Workflow")
      saveFunction(esWB_Status_History, self._WorkflowStatusHistory)
        .then((ignore) => {
          let LogRecs = _.flatMap(self._WorkflowStatusHistory, (aRow) => aRow.WB_WorflowStatusHistoryLogRows)
          return saveFunction(esWB_Status_History_Log, LogRecs)
        })
        .then((ignore) => {
          return saveFunction(esWB_User_Reviewers, self._UserReviewerList)
        })
        .then((ignore) => {
          // Should we also save the header row ?
          let record = self._options.Record
          if(!record){ return ASync.resolve() }
          let mapper = record._mapper()
          if(bDebug) {
            console.log(`Saving WF Record: ${self._workflowProcessorInstanceId}: `)
            console.log(JSON.stringify(record))
          }
          return saveFunction(mapper.name, record)

        })
        .then((ignore) => {
          // Run Save Extension
          return self._handleExtensionExecution("Save", [self, bUseBatch, options])
        })
        .then((ignore) => {
          self.WorkflowProgressProvider.finish()
          resolve()
        })
        .catch((err) => {
          self.WorkflowProgressProvider.exception(err)
          error(err)
        })
    })
  }

  get SaveEnabled(): boolean {
    return this._SaveEnabled
  }

  OnSaved(options?: any): Promise<void> {
    const self = this

    if(!self.OnSavedEnabled){ return ASync.resolve() }

    return new Promise<void>((resolve, error) => {

      self._handleExtensionExecution("OnSaved", [self, options || {}])
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  get OnSavedEnabled(): boolean {
    return this._OnSavedEnabled
  }

  OnReloaded(): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {


      self._handleExtensionExecution("OnReloaded", [self])
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })
  }

  getStateType(sStateType: string): WB_WorkflowStatusRow | WB_WorkflowStatusRow[] {
    if(!this.bIsLoaded){ return undefined }

    let returnValue = _.filter(this.Workflow.WB_WorkflowStatusRows, (aRow) => (aRow.isActive && aRow.cif.STATUS_TYPE == sStateType))
    if(_.isEmpty(returnValue)){ return undefined}
    if(returnValue.length == 1){ return returnValue[0]}
    return returnValue
  }

  getState(iStateId: number): WB_WorkflowStatusRow {

    let returnValue = _.filter(this.Workflow.WB_WorkflowStatusRows, (aRow) => (aRow.isActive && aRow.cif.WB_STATUS_ID == iStateId))
    if(_.isEmpty(returnValue)){ return undefined}
    return returnValue[0]
  }

  setState(iCurrStateId?: number, iNextStateId?: number, options?: setStateOptions): Promise<void> {
    const self = this
    let opts: IWorkflowPolicyFields = {}
    _.defaults(opts, options, {bNotify: true})

    return new Promise<void>((resolve, error) => {

      async function AsyncSetState(): Promise<void> {
        if(!_.isUndefined(iCurrStateId)){
          //
          self._CurrentStateId = iCurrStateId
          self._CurrentState = self.getState(iCurrStateId)
          let rec:any = self._options.Record
          let curStateFieldName = self._options.CurrentStateIdFieldName
          if(rec && !_.isEmpty(curStateFieldName)){
            let beforeValue = rec[curStateFieldName]
            rec[curStateFieldName] = self._CurrentStateId
            if(bDebug) {
              console.log(`State Change: ${self._workflowProcessorInstanceId} CurrentState (${self._CurrentStateId}), was (${beforeValue}): `)
              console.log(JSON.stringify(rec))
            }
          }
        }

        if(!_.isUndefined(iNextStateId)){
          self._NextStateId = iNextStateId
          self._NextState = self.getState(iNextStateId)
          let rec:any = self._options.Record
          let nextStateFieldName = self._options.NextStateIdFieldName
          if(rec && !_.isEmpty(nextStateFieldName)){
            let beforeValue = rec[nextStateFieldName]
            rec[nextStateFieldName] = self._NextStateId
            if(bDebug) {
              console.log(`State Change: ${self._workflowProcessorInstanceId} NextState (${self._NextStateId}), was (${beforeValue}): `)
              console.log(JSON.stringify(rec))
            }
          }
        }

        await self.updateNextStates(opts)

        await self.updateApprovers(opts)

      }


      AsyncSetState()
        .then((ignore) => {
          self.notifyChanged()
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  setStateType(sCurrStateType: string, sNextStateType?: string, options?: setStateOptions): Promise<void> {
    const self = this

    let curId = undefined
    let nextId = undefined
    if(!_.isEmpty(sCurrStateType)){
      let cur = self.getStateType(sCurrStateType)
      if(cur && _.isArray(cur)){
        curId = cur[0].cif.WB_STATUS_ID
      } else if(cur) {
        curId = (<any>cur).cif.WB_STATUS_ID
      }
    }
    if(!_.isEmpty(sNextStateType)){
      let next = self.getStateType(sNextStateType)
      if(next && _.isArray(next)){
        nextId = next[0].cif.WB_STATUS_ID
      } else if(next) {
        nextId = (<any>next).cif.WB_STATUS_ID
      }
    }

    return self.setState(curId, nextId, options)

  }

  setPolicyFields(pOpts: IWorkflowPolicyFields): void {
    let opts: IWorkflowPolicyFields = {}
    _.defaults(opts, pOpts, {bNotify: true})

    let fieldsToUpdate = ['WorkflowVisible','CurrentStateVisible', 'NextStateEditable', 'NextStateVisible','ValidateEnabled', 'SaveEnabled', 'OnSavedEnabled' ]
    _.forEach(fieldsToUpdate, (aFieldName) => {
      if(!(aFieldName in opts)) { return }
      switch (aFieldName) {
        case 'WorkflowVisible':
          this._WorkflowVisible = opts.WorkflowVisible
          break;

        case 'CurrentStateVisible':
          this._CurrentStateVisible = opts.CurrentStateVisible
          break;

        case 'NextStateEditable':
          this._NextStateEditable = opts.NextStateEditable
          break;

        case 'NextStateVisible':
          this._NextStateVisible = opts.NextStateVisible
          break;

        case 'ValidateEnabled':
          this._ValidateEnabled = opts.ValidateEnabled
          break;

        case 'SaveEnabled':
          this._SaveEnabled = opts.SaveEnabled
          break;

        case 'OnSavedEnabled':
          this._OnSavedEnabled = opts.OnSavedEnabled
          break;
      }
    })

    if(opts.bNotify){
      this.notifyChanged()
    }

  }

  getPolicyFields(): IWorkflowPolicyFields {
    return {
      WorkflowVisible:     this._WorkflowVisible,
      CurrentStateVisible: this._CurrentStateVisible,
      NextStateVisible:    this._NextStateVisible,
      NextStateEditable:   this._NextStateEditable,
      ValidateEnabled:     this._ValidateEnabled,
      SaveEnabled:         this._SaveEnabled,
      OnSavedEnabled:      this._OnSavedEnabled
    }
  }

  private updateNextStates(pOpts?: {bNotify?: boolean}): Promise<void> {
    const self = this
    const opts:any = {}
    _.defaults(opts, pOpts, {bNotify: true})

    return new Promise<void>((resolve, error) => {
      if(_.isEmpty(self._CurrentState)){
        self._NextStates = []
        if(opts.bNotify){ self.notifyChanged() }
        resolve()
      }

      let dctNextStates: {[id: number]: WB_WorkflowStatusRow} = {}
      dctNextStates[self._CurrentState.cif.WB_STATUS_ID] = self._CurrentState

      _.forEach(self._CurrentState.WB_WorkflowStatusRelationshipRows, (aRel: WB_WorkflowStatusRelationshipRow) => {
        if(_.isEmpty(aRel.WB_WorkflowStatusRow_Next)){ return }
        if(_.isEmpty(aRel.WB_DomainItemRow_Role)){ return }
        if(self._usrContext.hasRoleId(aRel.WB_DomainItemRow_Role.cif.DOMAIN_ITEM_ID, self._options.WB_Cust_Id)){
          dctNextStates[aRel.WB_WorkflowStatusRow_Next.cif.WB_STATUS_ID] = aRel.WB_WorkflowStatusRow_Next
        }
      })

      self._NextStates = _.values(dctNextStates)
      if(opts.bNotify){ self.notifyChanged() }
      resolve()
    })
  }

  private updateApprovers(pOpts?: {bNotify?: boolean}): Promise<void> {
    const self = this
    const opts:any = {}
    _.defaults(opts, pOpts, {bNotify: true})

    return new Promise<void>((resolve, error) => {

      async function RunUpdateApprovers(){
        self._bApproverRequired = false
        self._bUseApproverList = false
        self._ApproverList = []
        self._bUseReviewerList = false

        if(_.isEmpty(self._CurrentState)){
          return
        }

        if(!self._CurrentState.StatusTypeIsRequestingApproval){
          await self.resetNextUser()
          await self.updateNextUserRecord({bNotify: false})
          return
        }

        self._bApproverRequired = true

        let sPolicy = await self._handleExtensionExecutionWithReturn("GetApproverPolicy", [self], ApproverPolicy.None )
        switch (sPolicy) {
          case ApproverPolicy.None:
            self._ApproverList = []
            break;

          case ApproverPolicy.ApproverList:
            self._bUseApproverList = true
            self._ApproverList = await self._handleExtensionExecutionWithReturn("GetApproverList", [self], [])
            if(!_.isEmpty(self._ApproverList)){
              let anApprover = self._ApproverList[0]
              self._NextUserId = anApprover.cif.WB_AUTHUSR_ID
              self._NextUser = anApprover
            }
            break;

          case ApproverPolicy.ReviewerList:
            self._bUseReviewerList = true
            await self._handleExtensionExecution("SyncReviewerList", [self])
            break;
        }

      }

      RunUpdateApprovers()
        .then((ignore)=> {
          if(opts.bNotify){ self.notifyChanged() }
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  private updateNextUserRecord(pOpts?: {bNotify?: boolean}): Promise<void> {
    const self = this
    const opts: any = {}
    _.defaults(opts, pOpts, {bNotify: true})

    return new Promise<void>((resolve, error) => {

      let findUserUserRec = undefined
      if(self._NextUserId > 0){
        findUserUserRec = self.dbContext.find(esWB_User, self._NextUserId)
      } else {
        findUserUserRec = ASync.resolve(undefined)
      }
      findUserUserRec
        .then((UserRec: WB_UserRow) => {
          if(!_.isEmpty(UserRec)){
            if(_.isArray(UserRec)){ UserRec = UserRec[0]}
            if(self._NextUserId == UserRec.cif.WB_AUTHUSR_ID){
              self._NextUser = UserRec
            }
          }
          if(opts.bNotify){ self.notifyChanged() }
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  private resetNextUser(): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {
      let rec: any = self._options.Record
      if (rec && !_.isEmpty(self._options.OwnerUserIdFieldName)) {
        let ownUserId = _.toNumber(rec[self._options.OwnerUserIdFieldName]) || 0
        self._NextUserId = ownUserId
        resolve()
      } else {
        resolve()
      }

    })

  }

  private _handleExtensionExecution(sFunctionName: string, functionArgs: any[]): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      let applyArgs = functionArgs || []


      let sBeforeName = sFunctionName + "Before"
      let sAfterName = sFunctionName + "After"

      function findExtensionWithFunction(sFuncName: string) {
        for (let idx = 0; idx < self._extensions.length; idx++) {
          let ext: any = self._extensions[idx]
          if (_.isFunction(ext[sFuncName])) {
            return ext
          }
        }
        return undefined
      }

      let beforePromise: Promise<any> = undefined
      //
      let beforeFuncExt = findExtensionWithFunction(sBeforeName)
      if (!_.isUndefined(beforeFuncExt)) {
        beforePromise = beforeFuncExt[sBeforeName].apply(beforeFuncExt, applyArgs)
      } else {
        beforePromise = ASync.resolve(true)
      }

      beforePromise
        .then((res) => {
          let mainPromise: Promise<any> = undefined
          let mainFuncExt = findExtensionWithFunction(sFunctionName)
          if (!_.isUndefined(mainFuncExt)) {
            mainPromise = mainFuncExt[sFunctionName].apply(mainFuncExt, applyArgs)
          } else {
            mainPromise = ASync.resolve(true)
          }

          return mainPromise
        })
        .then((res) => {
          let afterPromise: Promise<any> = undefined
          let afterFuncExt = findExtensionWithFunction(sAfterName)
          if (!_.isUndefined(afterFuncExt)) {
            let ext
            afterPromise = afterFuncExt[sAfterName].apply(afterFuncExt, applyArgs)
          } else {
            afterPromise = ASync.resolve(true)
          }

          return afterPromise
        })
        .then((res) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })
    })

  }

  private _handleExtensionExecutionWithReturn(sFunctionName: string, functionArgs: any[], defaultValue: any): Promise<any> {
    const self = this

    return new Promise<void>((resolve, error) => {

      let applyArgs = functionArgs || []


      function findFunctionExt(sFuncName: string) {
        for (let idx = 0; idx < self._extensions.length; idx++) {
          let ext: any = self._extensions[idx]
          if (_.isFunction(ext[sFuncName])) {
            return ext
          }
        }
        return undefined
      }

      let mainPromise: Promise<any> = undefined
      let mainFuncExt = findFunctionExt(sFunctionName)
      if (!_.isUndefined(mainFuncExt)) {
        mainPromise = mainFuncExt[sFunctionName].apply(mainFuncExt, applyArgs)
      } else {
        mainPromise = ASync.resolve(defaultValue)
      }

      mainPromise
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          error(err)
        })
    })

  }

  private notifyChanged(){
    this._PolicyChanged.next(this)
  }

}